const InventoryRequestStatus = Object.freeze({
  Requested: 1,
  PendingEVP: 2,
  Approved: 3,
  Denied: 4,
  Closed: 5,
});
export default InventoryRequestStatus;
